import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-dentisterie',
  imports: [RouterOutlet],
  templateUrl: './main-dentisterie.component.html',
  styleUrl: './main-dentisterie.component.scss'
})
export class MainDentisterieComponent {}
